import BrandSlider from "../../../components/Brands/Brands";
import NavCategoryPage from "./NavbarCategory";
import { useNavigate } from "react-router-dom";

const CategoryThree = ({ selectedCategory }) => {
   const navigate = useNavigate();
  return (
    <>
     

      <NavCategoryPage slug={selectedCategory} />

      {/* ✅ HERO BANNER */}
      <div
        style={{
          marginTop: "40px",
          position: "relative",
          width: "100%",
          height: "450px",
          backgroundImage:
            "url('/kids.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* OVERLAY */}
        <div
        
        />

        {/* TEXT CONTENT */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: "60px",
            color: "#fff",
            maxWidth: "500px",
          }}
        >
          <h2
            style={{
              fontSize: "42px",
              fontWeight: "700",
              marginBottom: "16px",
              lineHeight: "1.2",
              textTransform: "capitalize",
            }}
          >
            cute.comfy.cool
          </h2>

          <p
            style={{
              fontSize: "17px",
              lineHeight: "1.7",
              marginBottom: "24px",
              opacity: 0.95,
            }}
          >
            Trendy outfits your little ones will love to wear every day.
          </p>

          <button    onClick={() => navigate("/shop")}
            style={{
              width: "fit-content",
              padding: "14px 28px",
              backgroundColor: "#ffffff",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s ease",
            }}
          >
            Shop Kids Collection
          </button>
        </div>
      </div>
      <div>
        <BrandSlider/>
      </div>
    </>
  );
};

export default CategoryThree;